function Footer(){
    return(
        <div class="footer">
        <div class="footer__one">
            <div class="footer__one__s1">
                <p>Udemey Bussiness</p>
                <p>Teach on Udemy</p>
                <p>Get the app</p>
                <p>About Us</p>
                <p>Contact Us</p>
            </div>
            <div class="footer__one__s2">
                <p>Careers</p>
                <p>Blog</p>
                <p>Help and Support</p>
                <p>Affiliate</p>
                <p>Investors</p>
            </div>
        </div>
        <div class="footer__two">
            <h1>Udemy</h1>
            <p>&copy;Udemy,Inc</p>
        </div>
    </div>
    )
}

export default Footer